import { Button, Text } from '@adobe/react-spectrum';
import Info from '@spectrum-icons/workflow/Info';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  min-height: 48px;
  background-color: var(${(props) => props.$bgColor});
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--spectrum-global-color-static-gray-50);
  box-sizing: border-box;
`;

const ContentContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  max-width: 1440px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

const TextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ArmBanner = () => {
  return (
    <Container $bgColor="--spectrum-global-color-static-blue">
      <ContentContainer>
        <TextContainer>
          <Info size="S" flexShrink={0} />
          <Text flexGrow={1} marginX="size-125">
            Are you using a new Windows ARM based device? If so, extensions and plug-ins are not yet supported.
          </Text>
        </TextContainer>
        <Button
          flexShrink={0}
          variant="overBackground"
          justifySelf="end"
          elementType="a"
          href="https://helpx.adobe.com/creative-cloud/kb/troubleshoot-common-addon-installation-issues.html#marketplace-tab-not-showing"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Learn more about ARM devices support"
        >
          Learn more
        </Button>
      </ContentContainer>
    </Container>
  );
};

export default ArmBanner;
